import React  from 'react';
import {TableView} from './table-view';
import {CompletedItemGenericView} from '../generic-view';

export const CompletedItemTableView = () => {
    return <CompletedItemGenericView innerView={({data}) => <TableView data={data}/>}/>
}